"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('map-distance', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("rect", {
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    x: "4",
    y: "4",
    width: "40",
    height: "40",
    rx: "3"
  }), _react.default.createElement("path", {
    d: "M12,38 L37,28",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    strokeDasharray: "2,6"
  }), _react.default.createElement("path", {
    d: "M14,31 C16.6666667,27.139426 18,24.4727593 18,23 C18,20.790861 16.209139,19 14,19 C11.790861,19 10,20.790861 10,23 C10,24.4727593 11.3333333,27.139426 14,31 Z",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.innerFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M34,22 C36.6666667,18.139426 38,15.4727593 38,14 C38,11.790861 36.209139,10 34,10 C31.790861,10 30,11.790861 30,14 C30,15.4727593 31.3333333,18.139426 34,22 Z",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.innerFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }))));
});

exports.default = _default;